import { notification } from 'antd';
import { Action, Thunk, thunk, action } from 'easy-peasy';
import { ClassConfigDelete, classConfigrationCreate, classCreate, classDelete, classSemesterConfigDelete, classSemesterConfigrationCreate, classSemesterYearById, classUpdate, createRegistrationdatawithAutoId, createRegistrationdatawithCustomIdUrl, departmentCreate, departmentDelete, departmentUpdate, fetchClass, fetchClassConfigurationlist, fetchClassSemesterConfigrationlist, fetchDepartment, fetchDistrictList, fetchacademicYearList, fetchSessionYear, fetchShift, getStudentListBySection, semesterYearById, createAcademicYear, deleteAcademicYear, updateAcademicYear, sessionYearCreate, sessionYearDelete, sessionYearUpdate, shiftCreate, shiftDelete, shiftUpdate, updateClassDepartmentList, updateSessionYearList, updateShiftList, updateStudentAddress, updateStudentBasicInfoList, fetchsectionList, createsectionList, updatesectionList, deletesectionList, deletegroupList, updategroupList, creategroupList, fetchgroupList, fetchstudentCategory, createstudentCategory, updatestudentCategory, deletestudentCategory, updateClassConfigurationSerial, fetchGroupConfigList, createGroupConfiguration, updateGroupConfigurationSerial, deleteGroupConfig, updateStudentSection, updatestudentCategroyValue, updateStudentGroupUrl, updateStudentPhoto, deleteStudentPhoto, fetchlistGroupbyClassConfig, fetchstudentListForMigration, fetchmigratedList, studentMigration, studentRegistrationDelete, deleteRegistrationStudentUrl, studentIdCardListUrl, studentIdCardSaveUrl, studentIdCardFrontPartDownload, studentIdCardBackPartDownload, classWiseReportUrl, sectionWiseReportUrl, groupWiseReportUrl, sectionWiseSummary, studentOverviewUrl, studentFeeReportUrl, studentMoneyReciptListUrl, studentMoneyReciptTemplateSaveUrl, studentTakePeriod, studentAllPeriodList, studentTakePeriodCreate, studentTakePeriodDelete, periodTimeConfigUrl, timeConfigurationList, timeConfigUpdate, timeConfigDelete, deviceIdMappingListUrl, deviceIdMappingListSave, studentAttendanceListUrl, studentAttendanceInputUrl, studentAttendanceUpdateListUrl, studentAttendanceUpdateUrl, studentAttendanceDetailsUrl, studentLeaveInput, dailySectionReport, sectionWiseDailySummaryReportUrl, sectionWiseMonthlyDetailsUrl, sectionWiseMonthlyReportUrl, studentTxtFileUrl, studentTxtFileSaveUrl, singleStudentSearchUrl, studentIdUpdateUrl, updateCustomIDUrl, studentEnableDisableListUrl, studentEnableDisableUrl, studentListGeneralMigrationList, saveStudentListGeneralMigration, fetchmigratedStudentList, pushbackmigratedStudentList, fetchStudentListMeritMigration, fetchfeeSubHeadListByClassId, fetchgetStudentListBySubjectWise, fetchsubjectConfigurationListByClasssIdAndGroupId, fetchmonthlyBlankAttendanceSheet, downloadTaughtList, fetchCategoryWiseBasicInfoUrl, fetchExamblankSheet, studentFeeReportDueUrl } from '../../../http/student/student';
import FileSaver from 'file-saver'

export interface Student {
    //////
    fetchacademicYearList: Thunk<Student>;
    createAcademicYear: Thunk<Student, any>;
    updateAcademicYear: Thunk<Student, any>;
    deleteAcademicYear: Thunk<Student, any>;
    setacademicYearList: Action<Student, any>;
    academicYearList: any;
    //////
    setacademicYearList2: Action<Student, any>;
    academicYearList2: any;
    fetchacademicYearList2: Thunk<Student>;

    setacademicYearList3: Action<Student, any>;
    academicYearList3: any;
    fetchacademicYearList3: Thunk<Student>;

    setacademicYearList4: Action<Student, any>;
    academicYearList4: any;
    fetchacademicYearList4: Thunk<Student>;
    //////
    fetchClassList: Thunk<Student>;
    createClass: Thunk<Student, any>;
    updateClass: Thunk<Student, any>;
    deleteClass: Thunk<Student, any>;
    setClassList: Action<Student, any>;
    classList: any;

    //////
    listGroupbyClassConfig: any;
    setlistGroupbyClassConfig: Action<Student, any>;
    fetchlistGroupbyClassConfig: Thunk<Student, any>;
    ////// 

    //////
    listGroupbyClassConfig2: any;
    setlistGroupbyClassConfig2: Action<Student, any>;
    fetchlistGroupbyClassConfig2: Thunk<Student, any>;
    ////// 

    //////
    listGroupbyClassConfig3: any;
    setlistGroupbyClassConfig3: Action<Student, any>;
    fetchlistGroupbyClassConfig3: Thunk<Student, any>;
    //////

    //////
    listGroupbyClassConfigsecond: any;
    setlistGroupbyClassConfigsecond: Action<Student, any>;
    fetchlistGroupbyClassConfigsecond: Thunk<Student, any>;
    ////// 

    //////
    listGroupbyClassConfigthird: any;
    setlistGroupbyClassConfigthird: Action<Student, any>;
    fetchlistGroupbyClassConfigthird: Thunk<Student, any>;
    ////// 

    //////
    subjectConfigurationListByClasssIdAndGroupId: any;
    setsubjectConfigurationListByClasssIdAndGroupId: Action<Student, any>;
    fetchsubjectConfigurationListByClasssIdAndGroupId: Thunk<Student, any>;
        //////

    //////
    getStudentListBySubjectWise: any;
    setgetStudentListBySubjectWise: Action<Student, any>;
    fetchgetStudentListBySubjectWise: Thunk<Student, any>;
    ////// 

    studentListForMigration: any;
    setstudentListForMigration: Action<Student, any>;
    fetchstudentListForMigration: Thunk<Student, any>;
    //////

    migratedList: any;
    setmigratedList: Action<Student, any>;
    fetchmigratedList: Thunk<Student, any>;
    //////    
    studentMigration: Thunk<Student, any>;
    //////

    fetchDepartmentList: Thunk<Student>;
    createDepartment: Thunk<Student, any>;
    updateDepartment: Thunk<Student, any>;
    deleteDepartment: Thunk<Student, any>;
    setDepartmentList: Action<Student, any>;
    departmentList: any;

    //////

    fetchSessionYearList: Thunk<Student>;
    createSessionYear: Thunk<Student, any>;
    updateSessionYear: Thunk<Student, any>;
    deleteSessionYear: Thunk<Student, any>;
    setSessionYearList: Action<Student, any>;
    sessionYearList: any;

    //////
    fetchClassConfigList: Thunk<Student>;
    createClassConfiguration: Thunk<Student, any>
    setClassConfigList: Action<Student, any>;
    classConfigList: any;
    deleteClassConfig: Thunk<Student, any>;
    updateClassConfigurationSerial: Thunk<Student, any>

    classConfigList2: any;
    setClassConfigList2: Action<Student, any>;
    fetchClassConfigList2: Thunk<Student>;

    classConfigList3: any;
    setClassConfigList3: Action<Student, any>;
    fetchClassConfigList3: Thunk<Student>;
    //////

    //////
    fetchGroupConfigList: Thunk<Student>;
    createGroupConfiguration: Thunk<Student, any>
    setGroupConfigList: Action<Student, any>;
    groupConfigList: any;
    deleteGroupConfig: Thunk<Student, any>;
    updateGroupConfigurationSerial: Thunk<Student, any>
    //////

    fetchclassSemesterYearConfigList: Thunk<Student>;
    createclassSemesterYearConfig: Thunk<Student, any>
    setclassSemesterYearConfigList: Action<Student, any>;
    classSemesterYearConfigList: any;
    deleteclassSemesterYearConfig: Thunk<Student, any>;

    //////

    fetchShiftList: Thunk<Student>;
    createShift: Thunk<Student, any>;
    updateShift: Thunk<Student, any>;
    deleteShift: Thunk<Student, any>;
    setShiftList: Action<Student, any>;
    shiftList: any;

    //////
    fetchSemesterYearByDepartment: Thunk<Student>;
    semesterYearByDepartmentId: any;
    setSemesterYearByDepartmentId: Action<Student, any>;

    /////

    registrationTableRow: any;
    setRegistrationTableRow: Action<Student, any>;
    createRegistrationdatawithAutoId: Thunk<Student, any>;
    createRegistrationdatawithCustomId: Thunk<Student, any>;
    createRegistrationdatawithCustomIdCheck: any;
    setcreateRegistrationdatawithCustomIdCheck: Action<Student, any>;    
    createRegistrationdatawithCustomIdData: any;
    setcreateRegistrationdatawithCustomIdData: Action<Student, any>;


    /////
    fetchStudentListByClassConfigId: Thunk<Student, any>;
    fetchStudentListByClassConfigIdMenu: Thunk<Student>;
    setStudentListByClassConfigId: Action<Student, any>,
    studentListByClassConfigId: any,
    updateStudentBasicInfo: Thunk<Student, any>;
    updateStudentSection: Thunk<Student, any>;
    updateStudentGroup: Thunk<Student, any>;
    updatestudentCategroyValue: Thunk<Student, any>;

    /////
    updateStudentClassDepartmentInfo: Thunk<Student, any>;

    /////
    updateStudentSessionyearInfo: Thunk<Student, any>;

    /////
    updateStudentShiftInfo: Thunk<Student, any>;

    /////
    updateStudentAddressInfo: Thunk<Student, any>;

    //////
    fetchsectionList: Thunk<Student>;
    createsectionList: Thunk<Student, any>;
    updatesectionList: Thunk<Student, any>;
    deletesectionList: Thunk<Student, any>;
    setsectionList: Action<Student, any>;
    sectionList: any;
    //////

    //////
    fetchgroupList: Thunk<Student>;
    creategroupList: Thunk<Student, any>;
    updategroupList: Thunk<Student, any>;
    deletegroupList: Thunk<Student, any>;
    groupList: any;
    setgroupList: Action<Student, any>;
    //////

    //////
    fetchstudentCategory: Thunk<Student>;
    createstudentCategory: Thunk<Student, any>;
    updatestudentCategory: Thunk<Student, any>;
    deletestudentCategory: Thunk<Student, any>;
    studentCategoryList: any;
    setstudentCategoryList: Action<Student, any>;
    //////
    updateStudentPhoto: Thunk<Student, any>
    deleteStudentPhoto: Thunk<Student, any>

    ///////
    fetchRegistrationstudentForDelete: Thunk<Student>;
    setRegistrationstudentForDeleteList: Action<Student, any>;
    registrationstudentForDeleteList: any;
    deleteRegistrationStudent: Thunk<Student, any>;

    //////
    fetchIdCardTemplate: Thunk<Student>;
    setIdCardTemplateList: Action<Student, any>;
    idCardTemplateList: any;
    idCardSaveTemplate: Thunk<Student, any>;
    fetchIdFrontCardPdf: Thunk<Student>;
    downloadTaughtList: Thunk<Student>;
    fetchIdBackCardPdf: Thunk<Student>;

    //////
    fetchClassWiseReport: Thunk<Student>;
    classWiseListReport: any;
    setClassWiseReport: Action<Student, any>;    
    
    fetchClassWiseReport2: Thunk<Student>;
    classWiseListReport2: any;
    setClassWiseReport2: Action<Student, any>;    
    
    fetchfeeSubHeadListByClassId: Thunk<Student, any>;
    feeSubHeadListByClassId: any;
    setfeeSubHeadListByClassId: Action<Student, any>;

    //////
    fetchSectionsWiseReport: Thunk<Student>;
    sectionWiseListReport: any;
    setSectionsWiseReport: Action<Student, any>;    
    
    fetchSectionsWiseReport2: Thunk<Student>;
    sectionWiseListReport2: any;
    setSectionsWiseReport2: Action<Student, any>;    
    
    fetchSectionsWiseReport3: Thunk<Student>;
    sectionWiseListReport3: any;
    setSectionsWiseReport3: Action<Student, any>;

    //////
    fetchGroupWiseReport: Thunk<Student>;
    groupWiseListReport: any;
    setGroupWiseReport: Action<Student, any>;

    //////
    fetchSectionWiseSummaryReport: Thunk<Student>;
    sectionWiseSummaryListReport: any;
    setSectionWiseSummaryReport: Action<Student, any>;

    //////
    fetchStudentOverviewReport: Thunk<Student>;
    studentOverviewListReport: any;
    setStudentOverviewReport: Action<Student, any>;

    //////
    fetchStudentOverFeesReport: Thunk<Student>;
    studentOverFeesListReport: any;
    setStudentOverFeesReport: Action<Student, any>;

    //////
    fetchStudentOverFeesDueReport: Thunk<Student>;
    studentOverFeesListDueReport: any;
    setStudentOverFeesDueReport: Action<Student, any>;

    //////
    fetchMoneyReciptTemplate: Thunk<Student>;
    setMoneyReciptTemplateList: Action<Student, any>;
    moneyReciptTemplateList: any;
    moneyRecipySaveTemplate: Thunk<Student, any>;

    //////
    fetchStudentAttendancePeriod: Thunk<Student>;
    studentAttendancePeriodList: any;
    setStudentAttendancePeriodList: Action<Student, any>;

    //////
    fetchStudentAttendanceAllPeriod: Thunk<Student>;
    studentAttendanceAllPeriodList: any;
    setStudentAttendanceAllPeriodList: Action<Student, any>;

    /////
    createAttendancePeriod: Thunk<Student, any>;
    deleteAttendancePeriod: Thunk<Student, any>;

    /////
    periodConfigurationSave: Thunk<Student, any>;
    fetchPeriodConfigurationList: Thunk<Student>;
    periodConfigurationList: any;
    setPeriodConfiguration: Action<Student, any>;
    periodConfigurationUpdate: Thunk<Student, any>;
    deletePeriodConfiguration: Thunk<Student, any>;

    ///// 
    fetchDeviceIdMappingList: Thunk<Student>;
    deviceIdMappingList: any;
    setDeviceIdMappingList: Action<Student, any>;
    saveDeviceIdMappingList: Thunk<Student, any>;

    /////
    fetchStudentAttendanceList: Thunk<Student>;
    studentAttendanceList: any;
    setStudentAttendanceList: Action<Student, any>;
    saveAttendanceInput: Thunk<Student, any>;

    ////
    fetchStudentAttendanceUpdateList: Thunk<Student>;
    studentAttendanceUpdateList: any;
    setStudentAttendanceUpdateList: Action<Student, any>;
    updateAttendanceInput: Thunk<Student, any>;

    //////
    fetchStudentAttendanceDetailsList: Thunk<Student>;
    studentAttendanceDetailsList: any;
    setStudentAttendanceDetailsList: Action<Student, any>;
    saveLeaveInput: Thunk<Student, any>;

    //////
    fetchStudentDailySectionReport: Thunk<Student>;
    studentDailySectionReport: any;
    setStudentDailySectionReport: Action<Student, any>;

    /////
    fetchStudentDailySectionWiseSummaryReport: Thunk<Student>;
    studentDailySectionWiseSummaryReport: any;
    setStudentDailySectionWiseSummaryReport: Action<Student, any>;

    /////
    fetchStudentMonthlySectionWiseSummaryDetails: Thunk<Student>;
    studentMonthlySectionWiseSummaryDetails: any;
    setStudentMonthlySectionWiseSummaryDetails: Action<Student, any>;

    /////
    fetchStudentMonthlySectionWiseSummaryReport: Thunk<Student>;
    studentMonthlySectionWiseSummaryReport: any;
    setStudentMonthlySectionWiseSummaryReport: Action<Student, any>;    
    
    fetchmonthlyBlankAttendanceSheet: Thunk<Student>;
    monthlyBlankAttendanceSheet: any;
    setmonthlyBlankAttendanceSheet: Action<Student, any>;

    /////
    studentTxtFile: Thunk<Student, any>;
    studentTxtFileList: any;
    setStudentTxtFileList: Action<Student, any>;
    studentTxtFileSave: Thunk<Student, any>;

    /////
    studentAttendanceAutoProcessList: any;
    setStudentAttendanceAutoProcessList: Action<Student, any>;

    /////
    fetchSingleStudentInfo: Thunk<Student>;
    singleStudentInfo: any;
    setSingleStudentInfo: Action<Student, any>;

    /////
    fetchStudentListForStudentIDUpdate: Thunk<Student>;
    studentListForStudentIDUpdate: any;
    setStudentListForStudentIDUpdate: Action<Student, any>;
    updateStudentListIDInfo: Thunk<Student, any>;

    //////
    fetchStudentEnableDisableList: Thunk<Student>;
    studentEnableDisableList: any;
    setStudentEnableDisableList: Action<Student, any>;
    storeEditableStore: Thunk<Student, any>;

    //////
    fetchStudentListGeneralMigration: Thunk<Student>;
    saveStudentListGeneralMigration: Thunk<Student, any>;
    studentListGeneralMigration: any;
    setStudentListGeneralMigration: Action<Student, any>;

    fetchStudentListMeritMigration: Thunk<Student>;
    studentListMeritMigration: any;
    setStudentListMeritMigration: Action<Student, any>;

    fetchmigratedStudentList: Thunk<Student, any>;
    pushbackmigratedStudentList: Thunk<Student, any>;
    migratedStudentList: any;
    setmigratedStudentList: Action<Student, any>;
    check: any;
    actionCheck: Action<Student, any>;
    
    loading: boolean;
    setLoading: Action<Student, boolean>;

    //////////////
    fetchCategoryWiseReport: Thunk<Student>;
    categoryWiseListReport: any;
    setCategoryWiseBasicInfoReport: Action<Student, any>;       
    
    //////////////
    fetchExamblankSheet: Thunk<Student>;
    examblankSheet: any;
    setExamblankSheet: Action<Student, any>;   
}

export const studentStore: Student = {
    academicYearList: null,
    academicYearList2: null,
    academicYearList3: null,
    academicYearList4: null,
    studentAttendanceAutoProcessList:[],
    classList: [],
    departmentList: [],
    sessionYearList: [],
    classConfigList: null,
    classConfigList2: null,
    classConfigList3: null,
    classSemesterYearConfigList: [],
    shiftList: null,
    semesterYearByDepartmentId: [],
    registrationTableRow: [],
    registrationstudentForDeleteList: [],
    studentListByClassConfigId: null,
    idCardTemplateList: [],
    moneyReciptTemplateList: "",
    classWiseListReport: [],
    classWiseListReport2: [],
    feeSubHeadListByClassId: [],
    sectionWiseListReport: [],
    sectionWiseListReport2: [],
    sectionWiseListReport3: [],
    groupWiseListReport: [],
    sectionWiseSummaryListReport: [],
    studentOverviewListReport: [],
    studentOverFeesListReport: [],
    studentOverFeesListDueReport: [],
    studentAttendancePeriodList: [],
    studentAttendanceAllPeriodList: [],
    periodConfigurationList: [],
    deviceIdMappingList: [],
    studentAttendanceList: [],
    studentAttendanceUpdateList: [],
    studentAttendanceDetailsList: [],
    studentDailySectionReport: [],
    studentDailySectionWiseSummaryReport: [],
    studentMonthlySectionWiseSummaryReport: [],
    monthlyBlankAttendanceSheet: [],
    studentMonthlySectionWiseSummaryDetails: [],
    studentTxtFileList: [],
    singleStudentInfo: [],
    studentListForStudentIDUpdate: [],
    studentEnableDisableList: [],
    studentListGeneralMigration: [],
    studentListMeritMigration: [],
    categoryWiseListReport:[],
    examblankSheet:[],
    loading: false,
    setLoading: action((state, payload) => {
        state.loading = payload;
    }),    
    createRegistrationdatawithCustomIdCheck: false,
    setcreateRegistrationdatawithCustomIdCheck: action((state, payload) => {
        state.createRegistrationdatawithCustomIdCheck = payload;
    }),    
    createRegistrationdatawithCustomIdData: '',
    setcreateRegistrationdatawithCustomIdData: action((state, payload) => {
        state.createRegistrationdatawithCustomIdCheck = payload;
    }),
    fetchacademicYearList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchacademicYearList();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();


            actions.setacademicYearList(body.item);
        } else {
            const body = await response.json();
            actions.setLoading(false);
        }
    }),
    setacademicYearList: action((state, payload) => {
        state.academicYearList = payload;
    }),
    fetchacademicYearList2: thunk(async (actions) => {
        const response = await fetchacademicYearList();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();


            actions.setacademicYearList2(body.item);
        } else {
            const body = await response.json();

        }
    }),
    setacademicYearList2: action((state, payload) => {
        state.academicYearList2 = payload;
    }),
    fetchacademicYearList3: thunk(async (actions) => {
        const response = await fetchacademicYearList();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setacademicYearList3(body.item);
        } else {
            const body = await response.json();

        }
    }),
    setacademicYearList3: action((state, payload) => {
        state.academicYearList3 = payload;
    }),

    fetchacademicYearList4: thunk(async (actions) => {
        const response = await fetchacademicYearList();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setacademicYearList4(body.item);
        } else {
            const body = await response.json();

        }
    }),
    setacademicYearList4: action((state, payload) => {
        state.academicYearList4 = payload;
    }),
    /////////////Session Config//////////////////
    createAcademicYear: thunk(async (actions, payload) => {
        const response = await createAcademicYear(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchacademicYearList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateAcademicYear: thunk(async (actions, payload) => {
        const response = await updateAcademicYear(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchacademicYearList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteAcademicYear: thunk(async (actions, payload) => {
        const response = await deleteAcademicYear(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchacademicYearList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    ///////////
    studentCategoryList: null,

    fetchstudentCategory: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchstudentCategory();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setLoading(false);


            actions.setstudentCategoryList(body.item);
        } else {
            const body = await response.json();
            actions.setLoading(false);
        }
    }),
    setstudentCategoryList: action((state, payload) => {
        state.studentCategoryList = payload;
    }),

    createstudentCategory: thunk(async (actions, payload) => {
        const response = await createstudentCategory(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchstudentCategory();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updatestudentCategory: thunk(async (actions, payload) => {
        const response = await updatestudentCategory(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchstudentCategory();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deletestudentCategory: thunk(async (actions, payload) => {
        const response = await deletestudentCategory(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchstudentCategory();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    //////////////

    ///////////
    groupList: null,

    fetchgroupList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchgroupList();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setgroupList(body.item);
        } else {
            const body = await response.json();
            actions.setLoading(false);
        }
    }),
    setgroupList: action((state, payload) => {
        state.groupList = payload;
    }),

    creategroupList: thunk(async (actions, payload) => {
        const response = await creategroupList(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchgroupList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updategroupList: thunk(async (actions, payload) => {
        const response = await updategroupList(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchgroupList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deletegroupList: thunk(async (actions, payload) => {
        const response = await deletegroupList(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchgroupList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    //////////////
    ///////////
    sectionList: null,

    fetchsectionList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchsectionList();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();


            actions.setsectionList(body.item);
        } else {
            const body = await response.json();
            actions.setLoading(false);
        }
    }),
    setsectionList: action((state, payload) => {
        state.sectionList = payload;
    }),

    createsectionList: thunk(async (actions, payload) => {
        const response = await createsectionList(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchsectionList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updatesectionList: thunk(async (actions, payload) => {
        const response = await updatesectionList(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchsectionList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deletesectionList: thunk(async (actions, payload) => {
        const response = await deletesectionList(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchsectionList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    //////////////

    /////////////Class Config//////////////////
    fetchClassList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchClass();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setClassList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setClassList: action((state, payload) => {
        state.classList = payload;
    }),

    createClass: thunk(async (actions, payload) => {
        const response = await classCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchClassList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateClass: thunk(async (actions, payload) => {
        const response = await classUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchClassList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteClass: thunk(async (actions, payload) => {
        const response = await classDelete(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchClassList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    ////////////Group Config///////////////////

    groupConfigList: [],

    fetchGroupConfigList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchGroupConfigList();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setGroupConfigList(body.item);

        } else {
            const body = await response.json();
            actions.setLoading(false);
        }
    }),

    setGroupConfigList: action((state, payload) => {
        state.groupConfigList = payload;
    }),

    createGroupConfiguration: thunk(async (actions, payload) => {
        const response = await createGroupConfiguration(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchGroupConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),

    updateGroupConfigurationSerial: thunk(async (actions, payload) => {
        const response = await updateGroupConfigurationSerial(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchGroupConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),

    deleteGroupConfig: thunk(async (actions, payload) => {
        const response = await deleteGroupConfig(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchGroupConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    ////////////Group Config///////////////////
    ////////////Department Config///////////////////
    fetchDepartmentList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchDepartment();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            console.log('body', body);

            actions.setDepartmentList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setDepartmentList: action((state, payload) => {
        state.departmentList = payload;
    }),

    createDepartment: thunk(async (actions, payload) => {
        const response = await departmentCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchDepartmentList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateDepartment: thunk(async (actions, payload) => {
        const response = await departmentUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchDepartmentList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteDepartment: thunk(async (actions, payload) => {
        const response = await departmentDelete(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchDepartmentList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    ////////////Session Year Config///////////////////
    fetchSessionYearList: thunk(async (actions) => {
        const response = await fetchSessionYear();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSessionYearList(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSessionYearList: action((state, payload) => {
        state.sessionYearList = payload;
    }),

    createSessionYear: thunk(async (actions, payload) => {
        const response = await sessionYearCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchSessionYearList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateSessionYear: thunk(async (actions, payload) => {
        const response = await sessionYearUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchSessionYearList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteSessionYear: thunk(async (actions, payload) => {
        const response = await sessionYearDelete(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchSessionYearList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    ////////////Class Department Config///////////////////

    fetchClassConfigList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchClassConfigurationlist();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setClassConfigList(body.item);

        } else {
            const body = await response.json();
            actions.setLoading(false);
        }
    }),

    setClassConfigList: action((state, payload) => {
        state.classConfigList = payload;
    }),

    fetchClassConfigList2: thunk(async (actions) => {
        const response = await fetchClassConfigurationlist();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setClassConfigList2(body.item);

        } else {
            const body = await response.json();

        }
    }),

    setClassConfigList2: action((state, payload) => {
        state.classConfigList2 = payload;
    }),

    fetchClassConfigList3: thunk(async (actions) => {
        const response = await fetchClassConfigurationlist();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setClassConfigList3(body.item);

        } else {
            const body = await response.json();

        }
    }),

    setClassConfigList3: action((state, payload) => {
        state.classConfigList3 = payload;
    }),

    createClassConfiguration: thunk(async (actions, payload) => {
        const response = await classConfigrationCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchClassConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),

    updateClassConfigurationSerial: thunk(async (actions, payload) => {
        const response = await updateClassConfigurationSerial(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchClassConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),

    deleteClassConfig: thunk(async (actions, payload) => {
        const response = await ClassConfigDelete(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchClassConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),


    ////////////Class Semester Config///////////////////


    fetchclassSemesterYearConfigList: thunk(async (actions) => {
        const response = await fetchClassSemesterConfigrationlist();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setclassSemesterYearConfigList(body.item);
            console.log('body.item', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),

    setclassSemesterYearConfigList: action((state, payload) => {
        state.classSemesterYearConfigList = payload;
    }),

    createclassSemesterYearConfig: thunk(async (actions, payload) => {

        const response = await classSemesterConfigrationCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                console.log('body', body);

                notification.success({ message: body.message })
                actions.fetchclassSemesterYearConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),

    deleteclassSemesterYearConfig: thunk(async (actions, payload) => {
        const response = await classSemesterConfigDelete(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchclassSemesterYearConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    ////////////Shift Year Config///////////////////
    fetchShiftList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchShift();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setShiftList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setShiftList: action((state, payload) => {
        state.shiftList = payload;
    }),

    createShift: thunk(async (actions, payload) => {
        const response = await shiftCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchShiftList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateShift: thunk(async (actions, payload) => {
        const response = await shiftUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchShiftList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteShift: thunk(async (actions, payload) => {
        const response = await shiftDelete(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchShiftList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    /////////////////Student Registration////////////////////////
    fetchSemesterYearByDepartment: thunk(async (actions, payload) => {
        const response = await classSemesterYearById(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterYearByDepartmentId(body.item);
            console.log('body', body);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterYearByDepartmentId: action((state, payload) => {
        state.semesterYearByDepartmentId = payload;
    }),

    setRegistrationTableRow: action((state, payload) => {
        var tableData = [
            {
                key: '',
                select: '',
                name: '',
                age: '',
                address: '',
                description: '',
            }
        ];
        state.registrationTableRow = tableData;
    }),

    createRegistrationdatawithAutoId: thunk(async (actions, payload) => {
        const response = await createRegistrationdatawithAutoId(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                console.log('body', body);
                notification.success({ message: body.message })
                // actions.fetchclassSemesterYearConfigList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),
    createRegistrationdatawithCustomId: thunk(async (actions, payload) => {
        const response = await createRegistrationdatawithCustomIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                // console.log('body', body);
                notification.success({ message: body.message })
                // actions.fetchclassSemesterYearConfigList();
            } else {
                actions.setcreateRegistrationdatawithCustomIdCheck(true);
                actions.setcreateRegistrationdatawithCustomIdData(body.message);
                //notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }

    }),
    ////////////////////////////setStudentListByClassConfigId
    check: false,
    actionCheck: action((state, payload) => {
        state.check = payload;
    }),
    fetchStudentListByClassConfigId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        actions.actionCheck(true);
        const response = await getStudentListBySection(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.item?.length > 0) {
                body?.item?.forEach((element, index) => {
                    element.index=index;
                });
                actions.setStudentListByClassConfigId(body?.item);
            } else {
                notification.error({ message: 'No data found' })
                actions.setStudentListByClassConfigId(null);
            }
            actions.actionCheck(false);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.actionCheck(false);
            actions.setLoading(false);
        }
    }),

    fetchStudentListByClassConfigIdMenu: thunk(async (actions) => {
        actions.setStudentListByClassConfigId(null);
    }),

    setStudentListByClassConfigId: action((state, payload) => {
        state.studentListByClassConfigId = payload
    }),

    updateStudentBasicInfo: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await updateStudentBasicInfoList(payload?.data);
        if (response.status === 201) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListByClassConfigId(payload?.id)
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
            actions.setLoading(false);
        }

    }),
    updateStudentSection: thunk(async (actions, payload) => {
        const response = await updateStudentSection(payload.value);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListByClassConfigId(payload.key);
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }

    }),

    updateStudentGroup: thunk(async (actions, payload) => {
        const response = await updateStudentGroupUrl(payload.value);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListByClassConfigId(payload.key);
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }

    }),
    updatestudentCategroyValue: thunk(async (actions, payload) => {
        
        const response = await updatestudentCategroyValue(payload.value);
        if (response.status === 201) {
            
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListByClassConfigId(payload.key);
            } else {
                notification.error({ message: body.message })
                
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
            
        }

    }),

    updateStudentClassDepartmentInfo: thunk(async (actions, payload) => {
        console.log('working', payload);
        const response = await updateClassDepartmentList(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }

    }),
    updateStudentSessionyearInfo: thunk(async (actions, payload) => {
        const response = await updateSessionYearList(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }

    }),
    updateStudentShiftInfo: thunk(async (actions, payload) => {
        const response = await updateShiftList(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    updateStudentAddressInfo: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await updateStudentAddress(payload.value);
        if (response.status === 201) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListByClassConfigId(payload.key);
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
            actions.setLoading(false);
        }
    }),
    updateStudentPhoto: thunk(async (actions, payload) => {
        actions.setLoading(true);
        var data = new FormData()
        data.append('file', payload.file)
        const response = await updateStudentPhoto(data, payload.id);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.messageType === 1) {
                notification.success({ message: body.message })
            }
            if (body?.messageType === 0) {
                notification.warn({ message: body.message })
            }
            actions.fetchStudentListByClassConfigId(payload.key);
        } else {
            notification.error({ message: "Something went wrong" })
            actions.setLoading(false);
        }
    }),
    deleteStudentPhoto: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await deleteStudentPhoto(payload.id);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListByClassConfigId(payload.key);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
            actions.setLoading(false);
        }
    }),

    listGroupbyClassConfig: null,
    fetchlistGroupbyClassConfig: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();

            actions.setlistGroupbyClassConfig(body?.item);
        } else {
            actions.setLoading(false);
        }
    }),

    setlistGroupbyClassConfig: action((state, payload) => {
        state.listGroupbyClassConfig = payload;
    }),

    listGroupbyClassConfig2: null,
    fetchlistGroupbyClassConfig2: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();

            actions.setlistGroupbyClassConfig2(body?.item);
        } else {
            actions.setLoading(false);
        }
    }),

    setlistGroupbyClassConfig2: action((state, payload) => {
        state.listGroupbyClassConfig2 = payload;
    }),

    listGroupbyClassConfig3: null,
    fetchlistGroupbyClassConfig3: thunk(async (actions, payload) => {
        actions.setLoading(true)
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();

            actions.setlistGroupbyClassConfig3(body?.item);
        } else {
            actions.setLoading(false);
        }
    }),

    setlistGroupbyClassConfig3: action((state, payload) => {
        state.listGroupbyClassConfig3 = payload;
    }),


    listGroupbyClassConfigsecond: null,
    fetchlistGroupbyClassConfigsecond: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();

            actions.setlistGroupbyClassConfigsecond(body?.item);
        } else {
            actions.setLoading(false);
        }
    }),

    setlistGroupbyClassConfigsecond: action((state, payload) => {
        state.listGroupbyClassConfigsecond = payload;
    }),


    listGroupbyClassConfigthird: null,
    fetchlistGroupbyClassConfigthird: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();

            actions.setlistGroupbyClassConfigthird(body?.item);
        } else {
            actions.setLoading(false);
        }
    }),

    setlistGroupbyClassConfigthird: action((state, payload) => {
        state.listGroupbyClassConfigthird = payload;
    }),    
    
    subjectConfigurationListByClasssIdAndGroupId: null,
    fetchsubjectConfigurationListByClasssIdAndGroupId: thunk(async (actions, payload) => {
        const response = await fetchsubjectConfigurationListByClasssIdAndGroupId(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();

            actions.setsubjectConfigurationListByClasssIdAndGroupId(body?.item);
        } else {

        }
    }),

    setsubjectConfigurationListByClasssIdAndGroupId: action((state, payload) => {
        state.subjectConfigurationListByClasssIdAndGroupId = payload;
    }),
   
    getStudentListBySubjectWise: [],
    fetchgetStudentListBySubjectWise: thunk(async (actions, payload) => {
         actions.setLoading(true);
        const response = await fetchgetStudentListBySubjectWise(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
            actions.setgetStudentListBySubjectWise(body?.item);
            } else {
                actions.setgetStudentListBySubjectWise([]);
                notification.warn({ message: "No data found" })
            }
        } else {
            notification.error({ message: "Something went wrong" })
        }
        actions.setLoading(false);
    }),

    setgetStudentListBySubjectWise: action((state, payload) => {
        state.getStudentListBySubjectWise = payload;
    }),

    studentListForMigration: null,
    fetchstudentListForMigration: thunk(async (actions, payload) => {
        const response = await fetchstudentListForMigration(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setstudentListForMigration(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setstudentListForMigration(null);
            }
        } else {

        }
    }),

    setstudentListForMigration: action((state, payload) => {
        state.studentListForMigration = payload;
    }),

    migratedList: null,
    fetchmigratedList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchmigratedList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setmigratedList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setmigratedList(null);
            }

        } else {
            actions.setLoading(false);
        }
    }),

    setmigratedList: action((state, payload) => {
        state.studentListForMigration = payload;
    }),

    studentMigration: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentMigration(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
            actions.setLoading(false);
        }
    }),

    fetchRegistrationstudentForDelete: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentRegistrationDelete(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setRegistrationstudentForDeleteList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setRegistrationstudentForDeleteList(body?.item);
            }

        } else {
            actions.setLoading(false);
        }
    }),



    deleteRegistrationStudent: thunk(async (actions, payload) => {
        console.log('payload --- ', payload);

        const response = await deleteRegistrationStudentUrl(payload.postData);
        console.log('response', response);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message });
                actions.fetchRegistrationstudentForDelete(payload.searchData);
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    setRegistrationstudentForDeleteList: action((state, payload) => {
        state.registrationstudentForDeleteList = payload;
    }),

    fetchIdCardTemplate: thunk(async (actions) => {
        const response = await studentIdCardListUrl();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item) {
                actions.setIdCardTemplateList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
    }),

    setIdCardTemplateList: action((state, payload) => {
        state.idCardTemplateList = payload;
    }),

    idCardSaveTemplate: thunk(async (actions, payload) => {
        const response = await studentIdCardSaveUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchIdCardTemplate();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    fetchIdFrontCardPdf: thunk(async (actions, payload) => {
        
        const response = await studentIdCardFrontPartDownload(payload);
        actions.setLoading(true);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "STUDENT_ID_CARD_FRONT.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            actions.setLoading(false);
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    
    downloadTaughtList: thunk(async (actions, payload) => {
        
        const response = await downloadTaughtList(payload);
        actions.setLoading(true);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const newBody =await response.json();
            if (newBody?.messageType===1){
                const body = await response.blob();
                var blob = new Blob([body], { type: "application/octet-stream" });
                var fileName = "TAUGHT_LIST.pdf";
                FileSaver.saveAs(blob, fileName);
            } else {
                notification.error({ message: "No data found" })
            }

        } else {
            actions.setLoading(false);
            const body = await response.json();
            notification.error({ message: "No data found" })
        }
    }),

    fetchIdBackCardPdf: thunk(async (actions, payload) => {
        const response = await studentIdCardBackPartDownload(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "STUDENT_ID_CARD_BACK.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchClassWiseReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await classWiseReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if ( body.item.length > 0) {
                actions.setClassWiseReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setClassWiseReport([]);
            }
        }  else {
            actions.setLoading(false);
        }
    }),

    setClassWiseReport: action((state, payload) => {
        state.classWiseListReport = payload;
    }),    
    
    fetchClassWiseReport2: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await classWiseReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if ( body.item.length > 0) {
                actions.setClassWiseReport2(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setClassWiseReport2([]);
                actions.setLoading(false);
            }
        }
    }),

    setClassWiseReport2: action((state, payload) => {
        state.classWiseListReport2 = payload;
    }),
    
    fetchfeeSubHeadListByClassId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchfeeSubHeadListByClassId(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if ( body.item.length > 0) {
                actions.setfeeSubHeadListByClassId(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setfeeSubHeadListByClassId([]);
                actions.setLoading(false);
            }
        }
    }),

    setfeeSubHeadListByClassId: action((state, payload) => {
        state.feeSubHeadListByClassId = payload;
    }),

    fetchSectionsWiseReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length>0) {
                actions.setSectionsWiseReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setSectionsWiseReport([]);
            }
        }
        else{
            actions.setLoading(false);
        }
    }),

    setSectionsWiseReport: action((state, payload) => {
        state.sectionWiseListReport = payload;
    }),
    
    fetchSectionsWiseReport2: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length>0) {
                actions.setSectionsWiseReport2(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setSectionsWiseReport2([]);
                actions.setLoading(false);
            }
        }
    }),

    setSectionsWiseReport2: action((state, payload) => {
        state.sectionWiseListReport2 = payload;
    }),    
    
    fetchSectionsWiseReport3: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length>0) {
                actions.setSectionsWiseReport3(body?.item.map((item, index)=>({...item, empty: ''})));
            } else {
                notification.error({ message: 'No data found' });
                actions.setSectionsWiseReport3([]);
                actions.setLoading(false);
            }
        }
    }),

    setSectionsWiseReport3: action((state, payload) => {
        state.sectionWiseListReport3 = payload;
    }),

    fetchGroupWiseReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await groupWiseReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setGroupWiseReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
            
        }
        actions.setLoading(false);
    }),

    setGroupWiseReport: action((state, payload) => {
        state.groupWiseListReport = payload;
    }),

    fetchSectionWiseSummaryReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseSummary();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setSectionWiseSummaryReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        else{
            actions.setLoading(false);
        }
    }),

    setSectionWiseSummaryReport: action((state, payload) => {
        state.sectionWiseSummaryListReport = payload;
    }),

    fetchStudentOverviewReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentOverviewUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setStudentOverviewReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),

    setStudentOverviewReport: action((state, payload) => {
        state.studentOverviewListReport = payload;
    }),

    fetchStudentOverFeesReport: thunk(async (actions, payload) => {
        const response = await studentFeeReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item) {
                actions.setStudentOverFeesReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
    }),

    setStudentOverFeesReport: action((state, payload) => {
        state.studentOverFeesListReport = payload;
    }),    
    
    fetchStudentOverFeesDueReport: thunk(async (actions, payload) => {
        const response = await studentFeeReportDueUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item) {
                actions.setStudentOverFeesDueReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
    }),

    setStudentOverFeesDueReport: action((state, payload) => {
        state.studentOverFeesListDueReport = payload;
    }),

    fetchMoneyReciptTemplate: thunk(async (actions) => {
        const response = await studentMoneyReciptListUrl();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item) {
                actions.setMoneyReciptTemplateList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
    }),

    setMoneyReciptTemplateList: action((state, payload) => {
        state.moneyReciptTemplateList = payload;
    }),

    moneyRecipySaveTemplate: thunk(async (actions, payload) => {
        const response = await studentMoneyReciptTemplateSaveUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchMoneyReciptTemplate();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    //////////Student attendance
    fetchStudentAttendancePeriod: thunk(async (actions) => {
        
        const response = await studentTakePeriod();
        actions.setLoading(true);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setStudentAttendancePeriodList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),

    setStudentAttendancePeriodList: action((state, payload,) => {
        state.studentAttendancePeriodList = payload;
    }),

    fetchStudentAttendanceAllPeriod: thunk(async (actions) => {
       actions.setLoading(true);
        const response = await studentAllPeriodList();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(true);
            const body = await response.json();
            if (body.item) {
                actions.setStudentAttendanceAllPeriodList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),

    setStudentAttendanceAllPeriodList: action((state, payload) => {
        state.studentAttendanceAllPeriodList = payload;
    }),

    createAttendancePeriod: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentTakePeriodCreate(payload);
        if (response.status === 201 || response.status === 200) {
         actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentAttendanceAllPeriod();
                actions.fetchStudentAttendancePeriod();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    deleteAttendancePeriod: thunk(async (actions, payload) => {
        const response = await studentTakePeriodDelete(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentAttendanceAllPeriod();
                actions.fetchStudentAttendancePeriod();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchPeriodConfigurationList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await timeConfigurationList();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setPeriodConfiguration(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),

    setPeriodConfiguration: action((state, payload) => {
        state.periodConfigurationList = payload;
    }),

    periodConfigurationSave: thunk(async (actions, payload) => {
        const response = await periodTimeConfigUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchPeriodConfigurationList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    periodConfigurationUpdate: thunk(async (actions, payload) => {
        const response = await timeConfigUpdate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchPeriodConfigurationList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    deletePeriodConfiguration: thunk(async (actions, payload) => {
        const response = await timeConfigDelete(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchPeriodConfigurationList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchDeviceIdMappingList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await deviceIdMappingListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.item.length > 0) {
                actions.setDeviceIdMappingList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setDeviceIdMappingList: action((state, payload) => {
        state.deviceIdMappingList = payload;
    }),

    saveDeviceIdMappingList: thunk(async (actions, postdata) => {
        actions.setLoading(true);
        const response = await deviceIdMappingListSave(postdata.payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                // actions.fetchDeviceIdMappingList(postdata.payloadSecond);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(true);
        }
    }),

    fetchStudentAttendanceList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentAttendanceListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length>0) {
                actions.setStudentAttendanceList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setStudentAttendanceList(body?.item);
            }
        } else {
            notification.error({ message: 'Something went wrong' });
        }
        actions.setLoading(false);
    }),

    setStudentAttendanceList: action((state, payload) => {
        state.studentAttendanceList = payload;
    }),
    saveAttendanceInput: thunk(async (actions, postdata) => {
        // console.log('postdata.payload', postdata.payload);
        const response = await studentAttendanceInputUrl(postdata.payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentAttendanceList(postdata.payloadSecond);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    fetchStudentAttendanceUpdateList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentAttendanceUpdateListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length>0) {
                actions.setStudentAttendanceUpdateList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setStudentAttendanceUpdateList(body?.item);
            } 
        } else {
            notification.error({ message: 'Something went wrong' });
        }
        actions.setLoading(false);
    }),
    setStudentAttendanceUpdateList: action((state, payload) => {
        state.studentAttendanceUpdateList = payload;
    }),

    updateAttendanceInput: thunk(async (actions, postdata) => {
        const response = await studentAttendanceUpdateUrl(postdata.payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentAttendanceUpdateList(postdata.payloadSecond);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchStudentAttendanceDetailsList: thunk(async (actions, payload) => {
        const response = await studentAttendanceDetailsUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item) {
                actions.setStudentAttendanceDetailsList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
    }),
    setStudentAttendanceDetailsList: action((state, payload) => {
        state.studentAttendanceDetailsList = payload;
    }),
    saveLeaveInput: thunk(async (actions, payload) => {
        const response = await studentLeaveInput(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    fetchStudentDailySectionReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await dailySectionReport(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.item.length > 0) {
                actions.setStudentDailySectionReport(body?.item);
            } else {
                actions.setStudentDailySectionReport([]);
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setStudentDailySectionReport: action((state, payload) => {
        state.studentDailySectionReport = payload;
    }),

    fetchStudentDailySectionWiseSummaryReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseDailySummaryReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setStudentDailySectionWiseSummaryReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setStudentDailySectionWiseSummaryReport: action((state, payload) => {
        state.studentDailySectionWiseSummaryReport = payload;
    }),

    fetchStudentMonthlySectionWiseSummaryDetails: thunk(async (actions, payload) => {
        
        actions.setLoading(true);
        const response = await sectionWiseMonthlyReportUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.item.length > 0) {
                actions.setStudentMonthlySectionWiseSummaryDetails(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setStudentMonthlySectionWiseSummaryDetails: action((state, payload) => {
        state.studentMonthlySectionWiseSummaryDetails = payload;
    }),

    fetchStudentMonthlySectionWiseSummaryReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseMonthlyDetailsUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setStudentMonthlySectionWiseSummaryReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setStudentMonthlySectionWiseSummaryReport([]);
            }
        } else {
            notification.error({ message: "Something went wrong" }) 
            actions.setLoading(false);
        }
    }),
    setStudentMonthlySectionWiseSummaryReport: action((state, payload) => {
        state.studentMonthlySectionWiseSummaryReport = payload;
    }),   
    
    fetchmonthlyBlankAttendanceSheet: thunk(async (actions, payload) => {
        const response = await fetchmonthlyBlankAttendanceSheet(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setmonthlyBlankAttendanceSheet(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setmonthlyBlankAttendanceSheet([]);
            }
        } else {
            notification.error({ message: "Something went wrong" }) 
        }
    }),
    setmonthlyBlankAttendanceSheet: action((state, payload) => {
        state.monthlyBlankAttendanceSheet = payload;
    }),

    studentTxtFileSave: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentTxtFileSaveUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                actions.setStudentTxtFileList(null);
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            notification.error({ message: "Something went wrong" })
            actions.setLoading(false);
        }
    }),

    studentTxtFile: thunk(async (actions, payload) => {
        actions.setLoading(true);
        var data = new FormData()
        data.append('file', payload.file)
        const response = await studentTxtFileUrl(data, payload.date);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.messageType === 1) {
                notification.success({ message: 'Fetch success, please save now' })
                actions.setStudentTxtFileList(body?.item);
            }
            if (body?.messageType === 0) {
                notification.warn({ message: body.message })
            }
            // actions.fetchstaffBasicInfoList();
        } else {
            notification.error({ message: "Something went wrong" })
            actions.setLoading(false);
        }
    }),

    setStudentTxtFileList: action((state, payload) => {
        state.studentTxtFileList = payload;
    }),

    setStudentAttendanceAutoProcessList: action((state, payload) => {
        state.studentAttendanceAutoProcessList = payload;
    }),

    fetchSingleStudentInfo: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await singleStudentSearchUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setSingleStudentInfo(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setSingleStudentInfo: action((state, payload) => {
        state.singleStudentInfo = payload;
    }),

    fetchStudentListForStudentIDUpdate: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentIdUpdateUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setStudentListForStudentIDUpdate(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setStudentListForStudentIDUpdate: action((state, payload) => {
        state.studentListForStudentIDUpdate = payload;
    }),
    updateStudentListIDInfo: thunk(async (actions, postdata) => {
        const response = await updateCustomIDUrl(postdata.payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListForStudentIDUpdate(postdata.classConfig)
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    fetchStudentEnableDisableList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentEnableDisableListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item) {
                actions.setStudentEnableDisableList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
            }
        }
        actions.setLoading(false);
    }),
    setStudentEnableDisableList: action((state, payload) => {
        state.studentEnableDisableList = payload;
    }),
    storeEditableStore: thunk(async (actions, postdata) => {
        const response = await studentEnableDisableUrl(postdata.payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentEnableDisableList(postdata.search)
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    fetchStudentListGeneralMigration: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await studentListGeneralMigrationList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                body?.item?.forEach((element, i) => element.newRoll = element.studentRoll)
                actions.setStudentListGeneralMigration(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setStudentListGeneralMigration([]);
            }
        }
        actions.setLoading(false);
    }),

    saveStudentListGeneralMigration: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await saveStudentListGeneralMigration(payload?.saveData);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchStudentListGeneralMigration(payload?.search)
                actions.fetchStudentListMeritMigration(payload?.search)
            }
            if (body?.messageType == 0) {
                notification.warn({ message: body.message })
            }
        }
        

        else {
            notification.error({ message: 'Something went wrong' });
            actions.setLoading(false);
        }
    }),
    setStudentListGeneralMigration: action((state, payload) => {
        state.studentListGeneralMigration = payload;
    }),

    fetchStudentListMeritMigration: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchStudentListMeritMigration(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                body?.item?.forEach((element, i) => element.newRoll = element.studentRoll)
                actions.setStudentListMeritMigration(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setStudentListMeritMigration([]);
            }
        }
        actions.setLoading(false);
    }),
    setStudentListMeritMigration: action((state, payload) => {
        state.studentListMeritMigration = payload;
    }),
    migratedStudentList: [],
    fetchmigratedStudentList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchmigratedStudentList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setmigratedStudentList(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setmigratedStudentList([]);
            }
        }
        actions.setLoading(false);
    }),
    setmigratedStudentList: action((state, payload) => {
        state.migratedStudentList = payload;
    }),
    pushbackmigratedStudentList: thunk(async (actions, payload) => {
        const response = await pushbackmigratedStudentList(payload?.saveData);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body?.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchmigratedStudentList(payload?.search)
            }
            if (body?.messageType == 0) {
                notification.warn({ message: body.message })
            }
        }

        else {
            notification.error({ message: 'Something went wrong' });
        }
    }),
    fetchCategoryWiseReport: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchCategoryWiseBasicInfoUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setCategoryWiseBasicInfoReport(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setCategoryWiseBasicInfoReport([]);
            }
        }
        actions.setLoading(false);
    }),
    setCategoryWiseBasicInfoReport: action((state, payload) => {
        state.categoryWiseListReport = payload;
    }),    
    
    fetchExamblankSheet: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamblankSheet(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.studentList?.length > 0) {
                actions.setExamblankSheet(body?.item);
            } else {
                notification.error({ message: 'No data found' });
                actions.setExamblankSheet([]);
            }
        }
        actions.setLoading(false);
    }),
    setExamblankSheet: action((state, payload) => {
        state.examblankSheet = payload;
    }),
}
